import { useState, useEffect, useRef } from "react";
import Typography from "../../components/Typography/Typography";
import { Link } from "react-router-dom";
import { LengthCard } from "../../components/LenghtCard/LenghtCard";
import { Toaster, toast } from "react-hot-toast";
import Button from "../../components/Button/Button";
import WeekCard from "./WeekCard";
import WeekNotes from "./WeekNotes";
import ApiManager from "../../api/ApiManager";

const frequenzaStudio = [
  { title: "Sempre sui libri", subtitle: "Tutti i giorni" },
  { title: "Quasi sempre", subtitle: "5–6 giorni" },
  { title: "A giorni alterni", subtitle: "3–4 giorni" },
  { title: "Quando capita", subtitle: "Meno di 3 giorni" },
];

const oreStudio = [
  { title: "Full immersion", subtitle: "5+ ore" },
  { title: "Studio solido", subtitle: "3–4 ore" },
  { title: "Un po' alla volta", subtitle: "1–2 ore" },
  { title: "Il minimo sindacale", subtitle: "Meno di 1 ora" },
];

const difficoltaTesi = [
  {
    title: "Trovare le fonti",
    subtitle: "Non so da dove iniziare o cosa cercare.",
  },
  {
    title: "Scrivere bene",
    subtitle: "Mettere le idee nero su bianco è una fatica.",
  },
  {
    title: "Organizzare il tutto",
    subtitle: "Ho materiale, ma non so come strutturarlo.",
  },
  {
    title: "Revisioni infinite",
    subtitle: "Temo di dover riscrivere tutto cento volte.",
  },
];

const RoadmapComponent = ({
  hasIndex,
  loading,
  aiResponse,
  setAiResponse,
  handleGenerateRoadmap,
  handleGenerateNuovo,
  checkEligibility,
  projectId,
  user_sub,
  getCookie,
  api,
  roadmapId,
}) => {
  const [selectedFrequenzaStudio, setSelectedFrequenzaStudio] = useState(0);
  const [selectedOreStudio, setSelectedOreStudio] = useState(0);
  const [selectedDifficolta, setSelectedDifficolta] = useState(0);
  const today = new Date();
  today.setMonth(today.getMonth() + 6); // Aggiungi 6 mesi
  const [selectedDate, setSelectedDate] = useState(
    today.toISOString().split("T")[0]
  );
  const scrollContainerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const dragThreshold = 5; // pixel threshold to determine if it's a drag vs click
  const apix = new ApiManager();

  // Submit form data to parent component
  const submitRoadmapForm = () => {
    const formData = {
      selectedFrequenzaStudio,
      selectedOreStudio,
      selectedDifficolta,
      selectedDate,
    };

    handleGenerateRoadmap(formData);
  };

  // Function to update roadmap when tasks are changed
  const updateRoadmap = (weekNumber, updatedTasks) => {
    // Create a copy of the current aiResponse
    const updatedResponse = { ...aiResponse };

    // Find the index of the week to update
    const weekIndex = updatedResponse.roadmap.findIndex(
      (week) =>
        week && typeof week === "object" && week.settimana === weekNumber
    );

    if (weekIndex !== -1) {
      updatedResponse.roadmap[weekIndex] = {
        ...updatedResponse.roadmap[weekIndex],
        tasks: updatedTasks,
      };

      setAiResponse(updatedResponse);

      const payload = {
        project_id: projectId,
        roadmap_id: roadmapId,
        ai_response: updatedResponse,
      };

      api
        .put("/roadmap/update", payload, {
          headers: { Authorization: `Bearer ${getCookie("id_token")}` },
        })
        .then((response) => {
          // TODO: toast
        })
        .catch((error) => {
          // TODO: toast
        });
    } else {
      console.error("Week not found in aiResponse:", weekNumber);
    }
  };

  // Aggiunge evento di trascinamento per scroll orizzontale
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const handleMouseDown = (e) => {
      setStartX(e.pageX - scrollContainer.offsetLeft);
      setScrollLeft(scrollContainer.scrollLeft);
    };

    const handleMouseUp = () => {
      if (Math.abs(scrollContainer.scrollLeft - scrollLeft) > dragThreshold) {
        // This was a drag operation
        setIsDragging(true);

        // Dispatch a custom event that child components can listen to
        const event = new CustomEvent("dragStateChange", {
          detail: { isDragging: true },
        });
        window.dispatchEvent(event);

        // Reset drag state after a short delay
        setTimeout(() => {
          setIsDragging(false);

          // Notify that dragging has ended
          const endEvent = new CustomEvent("dragStateChange", {
            detail: { isDragging: false },
          });
          window.dispatchEvent(endEvent);
        }, 50);
      }

      // Implementazione dell'effetto magnetico al rilascio
      if (scrollContainer) {
        const containerWidth = scrollContainer.clientWidth;
        // Include both loading-card and week-card classes, which are used for different states
        const cards = Array.from(
          scrollContainer.querySelectorAll(".loading-card, .week-card")
        );

        if (cards.length > 0) {
          let closestCard = null;
          let minDistance = Infinity;

          // Trova la card più vicina al centro
          cards.forEach((card) => {
            const cardMiddle = card.offsetLeft + card.offsetWidth / 2;
            const containerMiddle =
              scrollContainer.scrollLeft + containerWidth / 2;
            const distance = Math.abs(cardMiddle - containerMiddle);

            if (distance < minDistance) {
              minDistance = distance;
              closestCard = card;
            }
          });

          if (closestCard) {
            // Calcola la posizione per centrare la card e esegui lo scroll
            const newScrollLeft =
              closestCard.offsetLeft -
              containerWidth / 2 +
              closestCard.offsetWidth / 2;
            scrollContainer.scrollTo({
              left: newScrollLeft,
              behavior: "smooth",
            });
          }
        }
      }
    };

    const handleMouseMove = (e) => {
      if (e.buttons !== 1) return; // Only proceed if mouse button is pressed

      const x = e.pageX - scrollContainer.offsetLeft;
      const walk = (x - startX) * 1.5; // Moltiplicatore per aumentare la velocità dello scroll

      if (Math.abs(walk) > dragThreshold) {
        // Mark as dragging to prevent click events
        setIsDragging(true);

        // Dispatch an event that WeekCard can listen to
        const event = new CustomEvent("dragStateChange", {
          detail: { isDragging: true },
        });
        window.dispatchEvent(event);
      }

      scrollContainer.scrollLeft = scrollLeft - walk;
    };

    // Aggiungi tutti gli event listener
    scrollContainer.addEventListener("mousedown", handleMouseDown);
    document.addEventListener("mouseup", handleMouseUp);
    document.addEventListener("mousemove", handleMouseMove);

    // Rimuovi gli event listener quando il componente viene smontato
    return () => {
      scrollContainer.removeEventListener("mousedown", handleMouseDown);
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, [scrollLeft, startX, dragThreshold]);

  // useEffect(() => {
  //   const container = scrollContainerRef.current;
  //   if (!container) return;

  //   const onWheel = (e) => {
  //     if (e.deltaY === 0) return;
  //     e.preventDefault();
  //     container.scrollLeft += e.deltaY * 1.5; // Puoi aumentare un po' la velocità
  //   };

  //   container.addEventListener("wheel", onWheel, { passive: false });

  //   return () => {
  //     container.removeEventListener("wheel", onWheel);
  //   };
  // }, []);

  useEffect(() => {
    if (!scrollContainerRef.current) return;

    const container = scrollContainerRef.current;

    const timeoutId = setTimeout(() => {
      if (!container) return; // double-check dentro il timeout

      const firstCard = container.querySelector(
        ".week-card:first-child, .loading-card:first-child"
      );
      if (firstCard) {
        const containerWidth = container.clientWidth;
        const firstCardLeft = firstCard.offsetLeft;
        const firstCardWidth = firstCard.offsetWidth;
        const scrollLeft =
          firstCardLeft - containerWidth / 2 + firstCardWidth / 2;

        container.scrollTo({
          left: scrollLeft,
          behavior: "smooth",
        });
      }
    }, 100);

    return () => clearTimeout(timeoutId); // cleanup per sicurezza
  }, [loading]);

  const renderNotIndexView = () => {
    return (
      <>
        <div className="flex flex-col gap-3  pt-10">
          <Typography
            size="36"
            desktopSize="48"
            family="serif"
            weight="sb"
            align="center"
          >
            Manca poco!
          </Typography>
          <div className="flex flex-col gap-2 justify-center items-center">
            <Typography size="16" desktopSize="20" weight="md" align="center">
              Per generare la tua mappa di lavoro, crea prima il tuo indice!
            </Typography>
            <Link to="/client/index">
              <Typography
                size="16"
                desktopSize="20"
                weight="sb"
                align="center"
                underline={true}
              >
                Vai all'indice
              </Typography>
            </Link>
          </div>
        </div>

        <div className="h-96 w-auto overflow-hidden">
          <img
            alt="placeholderimage"
            src="/assets/images/illustrations/stats.png"
            className="object-contain w-full h-full"
          />
        </div>
      </>
    );
  };

  const renderFormView = () => {
    return (
      <div className="flex h-full w-full flex-col gap-6 md:gap-9 md:w-[40rem] items-top justify-center md:py-12">
        <div className="flex flex-col gap-3">
          <Typography
            size="32"
            desktopSize="48"
            family="serif"
            weight="sb"
            align="center"
          >
            La tesi su misura per te
          </Typography>
          <Typography
            size="16"
            desktopSize="20"
            weight="md"
            align="center"
            color="gray-600"
          >
            Rispondi a queste domande: ci servono per creare un piano che
            funzioni davvero.
          </Typography>
        </div>

        <div className="flex flex-col gap-3 w-full">
          {/* Data consegna */}
          <div className="flex flex-col gap-3 bg-gray-100 p-5 border-2 border-gray-150 rounded-[8px]">
            <div className="flex flex-col gap-1">
              <Typography weight="sb" size="16">
                Quand'è prevista la consegna della tua tesi?
              </Typography>
              <Typography size="12" weight="md" color="gray-600">
                Per capire quanto tempo puoi dedicare alla tesi e organizzare
                una roadmap realistica.
              </Typography>
            </div>

            <div className="grid grid-cols-2 gap-2 sm:grid-cols-2 md:grid-cols-4">
              <div className="flex flex-col gap-2 p-4 rounded-[8px] border-2 cursor-pointer transition border-gray-150 hover:border-gray-300 bg-white w-fit">
                <input
                  type="date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  className="w-fit"
                />
              </div>
            </div>
          </div>

          {/* Frequenza studio settimanale */}
          <div className="flex flex-col gap-3 bg-gray-100 p-5 border-2 border-gray-150 rounded-[8px]">
            <div className="flex flex-col gap-1">
              <Typography weight="sb" size="16">
                Quanti studi in media ogni settimana?
              </Typography>
              <Typography size="12" weight="md" color="gray-600">
                Per capire quanto tempo puoi dedicare alla tesi e organizzare
                una roadmap realistica.
              </Typography>
            </div>
            <div className="grid grid-cols-2 gap-2 sm:grid-cols-2 md:grid-cols-4">
              {frequenzaStudio.map((option, index) => (
                <LengthCard
                  key={option.title}
                  title={option.title}
                  subtitle={option.subtitle}
                  selected={selectedFrequenzaStudio === index}
                  onClick={() => setSelectedFrequenzaStudio(index)}
                />
              ))}
            </div>
          </div>

          {/* Ore di studio al giorno */}
          <div className="flex flex-col gap-3 bg-gray-100 p-5 border-2 border-gray-150 rounded-[8px]">
            <div className="flex flex-col gap-1">
              <Typography weight="sb" size="16">
                Quante ore dedichi allo studio al giorno?
              </Typography>
              <Typography size="12" weight="md" color="gray-600">
                Per capire quanto tempo puoi dedicare alla tesi e organizzare
                una roadmap realistica.
              </Typography>
            </div>
            <div className="grid grid-cols-2 gap-2 sm:grid-cols-2 md:grid-cols-4">
              {oreStudio.map((option, index) => (
                <LengthCard
                  key={option.title}
                  title={option.title}
                  subtitle={option.subtitle}
                  selected={selectedOreStudio === index}
                  onClick={() => setSelectedOreStudio(index)}
                />
              ))}
            </div>
          </div>

          {/* Difficoltà nella tesi */}
          <div className="flex flex-col gap-3 bg-gray-100 p-5 border-2 border-gray-150 rounded-[8px]">
            <div className="flex flex-col gap-1">
              <Typography weight="sb" size="16">
                Qual è la tua principale difficoltà con la tesi?
              </Typography>
              <Typography size="12" weight="md" color="gray-600">
                Per capire dove supportarti meglio durante il percorso.
              </Typography>
            </div>
            <div className="grid grid-cols-2 gap-2 sm:grid-cols-2 md:grid-cols-4">
              {difficoltaTesi.map((option, index) => (
                <LengthCard
                  key={option.title}
                  title={option.title}
                  subtitle={option.subtitle}
                  selected={selectedDifficolta === index}
                  onClick={() => setSelectedDifficolta(index)}
                />
              ))}
            </div>
          </div>
        </div>

        <Button
          size="md"
          variant="primary"
          width="full"
          text="Genera ora la tua roadmap"
          onClick={submitRoadmapForm}
        />
      </div>
    );
  };

  const renderLoadingView = () => {
    const loadingCards = Array.from({ length: 7 }, (_, index) => (
      <div
        key={index}
        className="loading-card flex-shrink-0 rounded-[12px] bg-gray-100 animate-pulse w-96 h-128 mx-4 z-10"
      />
    ));

    return (
      <div
        className="flex flex-col h-full w-full items-center justify-center"
        style={{ minHeight: "calc(100vh - 100px)" }}
      >
        <div
          ref={scrollContainerRef}
          className={`w-full flex flex-col md:flex-row px-4 pt-4 md:p-0 items-center overflow-x-auto snap-x snap-mandatory scrollbar-hidden h-auto md:h-144 ${
            isDragging ? "cursor-grabbing" : "cursor-grab"
          }`}
          style={{
            paddingLeft: window.innerWidth >= 768 ? "calc(50% - 192px)" : "0",
          }}
        >
          {/* Add spacing divs like in the actual roadmap */}
          <div className="flex-shrink-0 w-1/4 md:w-1/3 h-1" />

          {loadingCards}

          <div className="flex-shrink-0 w-1/4 md:w-1/3 h-1" />
        </div>
      </div>
    );
  };

  const renderRoadmapView = (ai_response) => {
    const weekElements = [];
    const isMobile = window.innerWidth < 768;

    weekElements.push(
      <div
        key="intro"
        className="week-card md:h-full flex-shrink-0 flex flex-col md:flex-row md:items-start items-center"
      >
        <WeekCard weekData="first" />
        <div className="flex md:mt-16 mt-0">
          <div
            className="bg-gray-200
                                   md:w-28 md:h-[2px]   // Desktop: linea orizzontale con margine top
                                   w-[2px] h-14" // Mobile: linea verticale senza mt
          />
        </div>
      </div>
    );

    // Process each week and note pair
    ai_response.roadmap.forEach((item, index) => {
      if (index % 2 === 0 && item !== "") {
        // This is a week
        const weekData = item;
        const isLast = index === ai_response.roadmap.length - 1; // Check if this is the last week

        weekElements.push(
          <div key={`week-${index}`} className="week-card flex-shrink-0">
            <WeekCard
              weekData={weekData}
              isLast={isLast}
              updateRoadmap={updateRoadmap}
            />
          </div>
        );

        // If not the last week, add a note component
        if (!isLast) {
          const noteIndex = index / 2; // Convert array index to week index
          const noteText = ai_response.roadmap[index + 1] || "";

          weekElements.push(
            <WeekNotes
              key={`note-${index}`}
              weekIndex={noteIndex}
              noteText={noteText}
              updateRoadmap={(updatedRoadmap) => {
                // Create a copy of the current AI response
                const updatedResponse = { ...ai_response };
                updatedResponse.roadmap = updatedRoadmap;

                // Update the AI response state
                setAiResponse(updatedResponse);

                // Save to API
                const payload = {
                  project_id: projectId,
                  roadmap_id: roadmapId,
                  ai_response: updatedResponse,
                };

                api
                  .put("/roadmap/update", payload, {
                    headers: {
                      Authorization: `Bearer ${getCookie("id_token")}`,
                    },
                  })
                  .then((response) => {
                    // TODO: toast
                  })
                  .catch((error) => {
                    // TODO: toast
                  });
              }}
              roadmapData={ai_response.roadmap}
            />
          );
        }
      }
    });

    return (
      <div className="flex flex-col h-full w-full items-center justify-center select-none">
        <div
          ref={scrollContainerRef}
          className={`w-full flex flex-col md:flex-row px-4 pt-4 md:p-0 items-center overflow-x-auto snap-x snap-mandatory scrollbar-hidden h-auto md:h-144 ${
            isDragging ? "cursor-grabbing" : "cursor-grab"
          }`}
        >
          <div className="flex-shrink-0 w-1/4 md:w-1/3 h-1" />

          {weekElements}

          <div className="flex-shrink-0 w-1/4 md:w-1/3 h-1" />
        </div>
      </div>
    );
  };

  const renderContent = () => {
    if (loading) {
      return renderLoadingView();
    }

    if (aiResponse && aiResponse.roadmap && aiResponse.roadmap.length > 0) {
      return renderRoadmapView(aiResponse);
    }

    if (!hasIndex) {
      return renderNotIndexView();
    }

    if (hasIndex && aiResponse === null) {
      return renderFormView();
    }
  };

  return (
    <>
      <Toaster />
      <div
        className={`w-full flex flex-col ${
          aiResponse && aiResponse.roadmap && aiResponse.roadmap.length > 0
            ? "h-full"
            : "h-fit"
        } items-center justify-between`}
      >
        {renderContent()}
      </div>
    </>
  );
};

export default RoadmapComponent;
